import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitDirection } from '../../SkeletonUnit.h'

export interface IProgramsListSkeletonUnitProps extends ISkeletonUnitProps {}

export const ProgramsListSkeletonUnit = ({
  children,
  direction = SkeletonUnitDirection.Column,
  ...rest
}: IProgramsListSkeletonUnitProps): JSX.Element => (
  <SkeletonUnit direction={direction} {...rest}>
    {children}
  </SkeletonUnit>
)
